/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const inventoryRoutes = {
  path: '/inventory',
  component: Layout,
  redirect: '/inventory/users',
  name: 'Inventory',
  alwaysShow: true,
  meta: {
    title: 'inventory',
    icon: 'Grid',
  },
  children: [
    /** inventory managements */
    {
      path: 'categories/list',
      component: () => import('../views/categories/List'),
      name: 'categoryList',
      meta: { title: 'categoryList', icon: 'Memo', permissions: ['category view'] },
    },
    {
      path: 'categories/edit/:id(\\d+)',
      component: () => import('../views/categories/components/CategoryEdit'),
      name: 'EditCategory',
      meta: {
        title: 'EditCategory',
        noCache: true,
        permissions: ['category view'],
      },
      hidden: true,
    },
    // brand routes
    {
      path: 'brands/list',
      component: () => import('../views/brand/List'),
      name: 'brandList',
      meta: { title: 'brandList', icon: 'Memo', permissions: ['brand view'] },
    },
    {
      path: 'brands/edit/:id(\\d+)',
      component: () => import('../views/brand/components/BrandEdit'),
      name: 'EditBrand',
      meta: {
        title: 'EditBrand',
        noCache: true,
        permissions: ['brand view'],
      },
      hidden: true,
    },
    // unit routes
    {
      path: 'units/list',
      component: () => import('../views/unit/List'),
      name: 'unitList',
      meta: { title: 'unitList', icon: 'Memo', permissions: ['unit view'] },
    },
    {
      path: 'units/edit/:id(\\d+)',
      component: () => import('../views/unit/components/UnitEdit'),
      name: 'EditUnit',
      meta: { title: 'EditUnit', noCache: true, permissions: ['unit view'] },
      hidden: true,
    },

    // product routes
    {
      path: 'product/list',
      component: () => import('../views/product/List'),
      name: 'ProductList',
      meta: { title: 'productList', icon: 'Memo', permissions: ['product view'] },
    },
    {
      path: 'products/edit/:id(\\d+)',
      component: () => import('../views/product/components/ProductEdit'),
      name: 'ProductEdit',
      meta: {
        title: 'ProductEdit',
        noCache: true,
        permissions: ['product view'],
      },
      hidden: true,
    },

    // warehouse routes
    {
      path: 'warehouses/list',
      component: () => import('../views/warehouse/List'),
      name: 'warehouseList',
      meta: {
        title: 'warehouseList',
        icon: 'Memo',
        permissions: ['warehouse view'],
      },
    },
    {
      path: 'warehouses/edit/:id(\\d+)',
      component: () => import('../views/warehouse/components/WarehouseEdit'),
      name: 'EditWarehouse',
      meta: {
        title: 'EditWarehouse',
        noCache: true,
        permissions: ['warehouse view'],
      },
      hidden: true,
    },
    // warehouse inventory routes
    {
      path: 'warehouse-inventory/list',
      component: () => import('../views/warehouse-inventory/List'),
      name: 'warehouseInventoryList',
      meta: {
        title: 'warehouseInventoryList',
        icon: 'Memo',
        permissions: ['warehouse inventory view'],
      },
    },
    {
      path: 'warehouse-inventory/pending-list',
      component: () => import('../views/warehouse-inventory/PendingList'),
      name: 'warehouseInventoryPendingList',
      meta: {
        title: 'warehouseInventoryPendingList',
        icon: 'Memo',
        permissions: ['warehouse inventory purchase pending view'],
      },
      hidden: true,
    },
    {
      path: 'receive-product/:id(\\d+)',
      component: () => import('../views/warehouse-inventory/ReceiveProduct'),
      name: 'warehouseInventoryReceiveProduct',
      meta: {
        title: 'warehouseInventoryReceiveProduct',
        icon: 'Memo',
        permissions: ['warehouse inventory receive'],
      },
      hidden: true,
    },
    {
      path: 'warehouse-inventory/transfer-list',
      component: () => import('../views/warehouse-inventory/TransferList'),
      name: 'warehouseInventoryTransferList',
      meta: {
        title: 'warehouseInventoryTransferList',
        icon: 'Memo',
        permissions: ['warehouse inventory transfer pending view'],
      },
      hidden: true,
    },
    {
      path: 'warehouse-inventory/transfer-receive/:id(\\d+)',
      component: () => import('../views/warehouse-inventory/TransferReceive'),
      name: 'warehouseInventoryTransferReceive',
      meta: {
        title: 'warehouseInventoryTransferReceive',
        icon: 'Memo',
        permissions: ['warehouse inventory transfer receive'],
      },
      hidden: true,
    },

    // stock routes
    {
      path: 'stock/list',
      component: () => import('../views/stock/List'),
      name: 'stockList',
      meta: {
        title: 'stockList',
        icon: 'Memo',
      },
      hidden: true,
    },

    // Transfer routes
    {
      path: 'transfer/list',
      component: () => import('../views/transfer/List'),
      name: 'transferList',
      meta: {
        title: 'transferList',
        icon: 'Memo',
        permissions: ['transfer view'],
      },
    },
    {
      path: 'transfers/Create',
      component: () => import('../views/transfer/Create'),
      name: 'transferCreate',
      meta: {
        title: 'transferCreate',
        icon: 'Memo',
      },
      hidden: true,
    },
    {
      path: 'transfers/view/:id(\\d+)',
      component: () => import('../views/transfer/View'),
      name: 'transferView',
      meta: {
        title: 'transferView',
        icon: 'Memo',
      },
      hidden: true,
    },
    {
      path: 'transfers/edit/:id',
      component: () => import('../views/transfer/Edit'),
      name: 'transferEdit',
      meta: {
        title: 'transferEdit',
        icon: 'Memo',
      },
      hidden: true,
    },
    {
      path: 'transfers/history',
      component: () => import('../views/transfer/History'),
      name: 'transferHistory',
      meta: {
        title: 'transferHistory',
        icon: 'Memo',
      },
      hidden: true,
    },
  ],
};

const expenseRoutes = {
  path: '/expenses',
  component: Layout,
  redirect: '/expenses/list',
  name: 'Expenses',
  meta: { title: 'Expenses', icon: 'Grid', permissions: ['expense view'] },
  children: [
    {
      path: 'list',
      component: () => import('../views/expense/List'),
      name: 'ExpenseList',
      meta: { title: 'Cashbook', icon: 'Memo', permissions: ['expense view'] },
    },
    {
      path: 'report',
      component: () => import('../views/expense/Report'),
      name: 'ExpenseReport',
      meta: { title: 'Expenses', icon: 'Memo', permissions: ['expense view'] },
      hidden: true,
    }
  ],
};

const reportRoutes = {
  path: '/reports',
  component: Layout,
  redirect: '/reports/reports',
  name: 'Reports',
  meta: { title: 'Reports', icon: 'Grid', permissions: ['report generate'] },
  children: [
    {
      path: 'reports',
      component: () => import('../views/report/Index'),
      name: 'inventoryReport',
      meta: { title: 'Reports', icon: 'Memo', permissions: ['report generate'] },
    },
    {
      path: 'ledger',
      component: () => import('../views/report/LedgerReport'),
      name: 'LedgerReport',
      meta: { title: 'Ledger Reports', icon: 'Memo', permissions: ['report generate'] },
      hidden: true,
    },
  ],
};

export { inventoryRoutes, expenseRoutes, reportRoutes };
